import { TourStep } from "./components/GuidedTour";
import { store } from "../../redux/store";
import { updateAddNodes, updateAddLinks } from "../../redux/features/nodes/nodes.slice";

export const inputGraphEditorTourSteps: TourStep[] = [
    {
        targetSelector: ".svgDualGraph",
        title: "The Canvas",
        description:
            "This is your drawing canvas. Click anywhere on the grid to add a room node.",
        placement: "bottom",
        onExit: () => {
            const nodes = store.getState().nodesState.nodes;
            if (nodes.length === 0) {
                const cx = Math.round((window.innerWidth / 2) / 20) * 20;
                const cy = Math.round((window.innerHeight / 2) / 20) * 20;
                store.dispatch(
                    updateAddNodes({
                        id: 0,
                        x: cx - 160,
                        y: cy,
                        label: "1",
                        color: "#FF9A56",
                        width: { max: 99999, min: 3 },
                        height: { max: 99999, min: 3 },
                        ratio: { max: 99999, min: 3 },
                    }),
                );
                store.dispatch(
                    updateAddNodes({
                        id: 1,
                        x: cx + 160,
                        y: cy,
                        label: "2",
                        color: "#FF9A56",
                        width: { max: 99999, min: 3 },
                        height: { max: 99999, min: 3 },
                        ratio: { max: 99999, min: 3 },
                    }),
                );
                store.dispatch(
                    updateAddLinks({ source: 0, target: 1, color: "black" }),
                );
            }
        },
    },
    {
        targetSelector: "[data-tour='plot-size']",
        title: "Plot Size",
        description:
            "Set the width and length of your plot here. If provided, all generated layouts will fit within these dimensions.",
        placement: "top",
    },
    {
        targetSelector: "[data-tour='left-sidebar']",
        title: "Left Sidebar — Rooms List",
        description:
            "View all the rooms (nodes) you've added. Each room shows its label and properties such as the width and the height. You can manage rooms from this panel.",
        placement: "right",
    },
    {
        targetSelector: "[data-tour='right-sidebar']",
        title: "Right Sidebar — Properties",
        description:
            "Configure plot dimensions, room constraints (width, height, area), and generate floor plan options. Toggle between rectangular and irregular plot shapes.",
        placement: "left",
    },
    {
        targetSelector: ".vertex",
        title: "Room Nodes",
        description:
            "Each circle represents a room. Hover over a node to see its editor. Drag from one node to another to create an adjacency (edge) between rooms.",
        placement: "auto",
    },
    {
        targetSelector: ".edge-group",
        title: "Adjacency Edges",
        description:
            "The lines connecting nodes represent adjacency relationships. Hover over an edge to change it to Adjacency, Non-Adjacency, or delete it.",
        placement: "auto",
    },
    {
        targetSelector: "[data-tour='generate-floorplans']",
        title: "Generate Floorplans",
        description:
            "Once you've set up your rooms and connections, click here to generate floor plan layouts based on your graph.",
        placement: "top",
    },
    {
        targetSelector: "[data-tour='edit-floorplan']",
        title: "Edit Floorplan",
        description:
            "After generating floorplans, select one and click here to open the Output Editor where you can customize walls, doors, and other details.",
        placement: "top",
    },
];

